/* eslint-disable no-underscore-dangle */
import axios, { AxiosError } from 'axios'
import { API_URL } from 'constants/apiUrl'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { refreshAccessToken, requestInterceptorCallback } from 'services/axios/publicInstance'

const privateInstance = axios.create({ baseURL: API_URL })

// eslint-disable-next-line
const requestPrivateInterceptor = privateInstance.interceptors.request.use(requestInterceptorCallback, function (error: AxiosError) {
  return Promise.reject(error)
})

createAuthRefreshInterceptor(privateInstance, refreshAccessToken, {})

export { privateInstance }
